import { Skeleton } from '@fox/atoms/src/skeleton/index';
import { nanoid } from 'nanoid';
import { useRef, useState } from 'react';
import { PaymentAddComponentProps } from '../../../contracts';
import {
	DEBIT_FORM_ACCOUNT_NAME_ELEMENT,
	DEBIT_FORM_ACCOUNT_NUMBER_ELEMENT,
	DEBIT_FORM_BSB_ELEMENT,
	DebitForm
} from '../direct-debit';
import { EZI_CUSTOMER_REF_ELEMENT, EziDebitEnvironmentSettings, useEziDebitClientScripts } from './shared';

export function EziDebitAddDirectDebit({
	onSuccess,
	settings,
	completeIntent,
	intentData,
	onCancel,
	showSave = true
}: PaymentAddComponentProps) {
	const ready = useEziDebitClientScripts(settings as EziDebitEnvironmentSettings);
	const intentId = intentData?.intentId;
	const [errors, setErrors] = useState<string[]>(intentId ? [] : ['Error occurred initialising add bank account form.']);
	const elementIDSuffix = useRef(nanoid());
	const submitFunc = submitData => {
		return new Promise((resolve, reject) => {
			window.eziDebit.saveCustomer({
				submitAction: 'SaveCustomerAccount',
				submitCallback: async data => {
					completeIntent(intentId!, '')
						.then(result => {
							onSuccess(result!);
							resolve(result);
						})
						.catch(result => {
							setErrors(['Unable to save bank account details']);
							reject(result);
						});
				},
				submitError: async data => {
					setErrors([data]);
					reject(data);
				},
				customerLastName: `${DEBIT_FORM_ACCOUNT_NAME_ELEMENT}-${elementIDSuffix.current}`,
				customerReference: EZI_CUSTOMER_REF_ELEMENT,

				accountName: `${DEBIT_FORM_ACCOUNT_NAME_ELEMENT}-${elementIDSuffix.current}`,
				accountBSB: `${DEBIT_FORM_BSB_ELEMENT}-${elementIDSuffix.current}`,
				accountNumber: `${DEBIT_FORM_ACCOUNT_NUMBER_ELEMENT}-${elementIDSuffix.current}`
			});
		});
	};

	if (!ready) return <Skeleton />;

	return (
		<div>
			<input type="hidden" value={intentId!} id={EZI_CUSTOMER_REF_ELEMENT} />
			<DebitForm submitFunc={submitFunc} onCancel={onCancel} showSave={showSave} elementIDSuffix={elementIDSuffix.current} />
		</div>
	);
}
